const rulesCache = new Map();
function rulesFor(locale) {
    let rules = rulesCache.get(locale);
    if (!rules) {
        rules = new Intl.PluralRules(locale);
        rulesCache.set(locale, rules);
    }
    return rules;
}
// selectPlural — форма для count; "other" — обязательная сеть безопасности при неполном наборе.
export function selectPlural(locale, count, forms) {
    const category = rulesFor(locale).select(count);
    return forms[category] ?? forms.other ?? "";
}
